import ToastV2 from '@shared/components/base/BaseToast';
import logger from '@shared/utils/error/logger';
import i18n from '@shared/i18n/index';
import { copy } from 'clipboard';

export function copyTextFunc(_text: string, _toast?: string): boolean {
	try {
		copy(_text);
		ToastV2.success(_toast);
		return true;
	} catch (error) {
		logger.error('copyTextFunc方法', 'copy link失败', error);
		ToastV2.error(i18n.get('Common_Failed_To_Copy_Toast'));
		return false;
	}
}
